<script setup lang="ts">
import { Log } from "@/interfaces/Log";
import { useAuthStore } from "@/stores/auth";
import { isArray } from "lodash";

interface Props {
  log: Log;
}

const props = defineProps<Props>();

const { user } = useAuthStore();

const formatDate = (dateString: string) =>
  new Date(dateString).toLocaleString();

const formatValue = (value: string | number | null) =>
  value && typeof value === "string" && value.includes(",")
    ? value.split(",").join(", ")
    : value;

const isObject = (value: any) =>
  typeof value === "object" && value !== null && !Array.isArray(value);
</script>
<template>
  <tr>
    <!-- Event of made -->
    <td class="px-4 py-4 whitespace-nowrap text-sm border-y-2">
      {{ log.description }}
    </td>

    <!-- User or System made the event  -->
    <td class="px-4 py-4 whitespace-nowrap text-sm border-y-2">
      {{ formatDate(log.createdAt) }}
    </td>

    <!--   Old data -->
    <td class="px-4 py-4 whitespace-nowrap text-sm border-y-2 bg-red-300">
      <ul v-if="log.properties.old">
          <li v-for="(value, key) in log.properties.old" :key="key">
          <template v-if="isObject(value)">
            <ul>
              <li v-for="(innerValue, innerKey) in value" :key="innerKey">
                <div class="flex gap-1">
                  <h3 class="text-normal text-blue-700">{{ innerKey }}:</h3>

                  <template v-if="isObject(innerValue)">
                    <ul>
                      <li
                        v-for="(deepValue, deepKey) in innerValue"
                        :key="deepKey"
                      >
                        <div class="flex items-center gap-1">
                          <h4
                            class="font-bold text-normal text-red-700"
                            v-if="deepValue"
                          >
                            {{ deepKey }}:
                          </h4>
                          <p
                            class="text-sm"
                            v-for="value in deepValue"
                            :key="value"
                          >
                            {{
                              deepValue.lenght < 0 ? "N/A" : formatValue(value)
                            }}
                          </p>
                        </div>
                      </li>
                    </ul>
                  </template>
                  <template v-else>
                    <p class="text-sm" v-if="isObject(innerValue)">
                      {{ formatValue(innerValue) }}
                    </p>
                    <p class="text-sm" v-for="value in innerValue" :key="value">
                      {{ formatValue(value) }}
                    </p>
                  </template>
                </div>
              </li>
            </ul>
          </template>
          <template v-else>
            <div class="flex gap-1">
              <h3 class="text-normal text-blue-700" v-if="value">{{ key }}:</h3>
              <p v-if="formatValue(value) !== null" class="text-sm">
                {{ formatValue(value) }}
              </p>
            </div>
          </template>
        </li>
      </ul>
      <ul v-else>
        N/A
      </ul>
    </td>

    <!--  New Data  -->
    <td class="px-4 py-4 whitespace-nowrap text-sm border-y-2 bg-green-300">
      <ul v-if="log.properties.attributes">
          <li v-for="(value, key) in log.properties.attributes" :key="key">
          {{}}
          <template v-if="isObject(value)">
            <ul class="flex flex-col gap-2">
              <li
                class="flex gap-1"
                v-for="(innerValue, innerKey) in value"
                :key="innerKey"
              >
                <div class="flex gap-1">
                  <h3 class="text-normal text-blue-700">{{ innerKey }}:</h3>
                  <template v-if="isObject(innerValue)">
                    <ul>
                      <li
                        v-for="(deepValue, deepKey) in innerValue"
                        :key="deepKey"
                      >
                        <div class="flex items-center gap-1">
                          <h4
                            class="font-bold text-normal text-red-700"
                            v-if="deepValue"
                          >
                            {{ deepKey }}:
                          </h4>

                          <div v-if="deepValue.length > 0">
                            <p
                              class="text-sm"
                              v-for="value in deepValue"
                              :key="value"
                            >
                              {{
                                deepValue.length < 0
                                  ? "N/A"
                                  : formatValue(value)
                              }}
                            </p>
                          </div>

                          <div v-else>
                            <p class="text-sm">N/A</p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </template>
                  <template v-else>
                    <p class="text-sm" v-if="isObject(innerValue)">
                      {{ formatValue(innerValue) }}
                    </p>
                    <p class="text-sm" v-for="value in innerValue" :key="value">
                      {{ formatValue(value) }}
                    </p>
                  </template>
                </div>
              </li>
            </ul>
          </template>
          <template v-else>
            <div class="flex gap-1" v-if="value">
              <h3 class="text-normal text-blue-700">{{ key }}:</h3>
              <p class="text-sm" v-if="!isArray(value)">
                {{ formatValue(value) }}
              </p>
              <div v-else>
                <div class="flex flex-col gap-1">
                  <p class="text-sm" :key="i" v-for="(v, i) in value">
                    {{ formatValue(v) }}
                  </p>
                </div>
              </div>
            </div>
          </template>
        </li>
      </ul>
      <ul v-else>
        N/A
      </ul>
    </td>
  </tr>
</template>
